module.exports = {
  catalogUrl: "/stac/collection.json", // Update this to Rosetta STAC API
  catalogTitle: null,
  catalogImage: null,
  allowExternalAccess: true, // Must be true if catalogUrl is not given
  allowedDomains: [],
  detectLocaleFromBrowser: true,
  storeLocale: true,
  locale: "en",
  fallbackLocale: "en",
  supportedLocales: [
    "en"
  ],
  apiCatalogPriority: null,
  useTileLayerAsFallback: false,
  displayGeoTiffByDefault: false,
  displayPreview: false,
  displayOverview: false,
  buildTileUrlTemplate: null,
  getMapSourceOptions: null,
  pathPrefix: "/",
  historyMode: "history",
  cardViewMode: "cards",
  cardViewSort: "asc",
  showKeywordsInItemCards: false,
  showKeywordsInCatalogCards: false,
  showThumbnailsAsAssets: false,
  searchResultsPerPage: null,
  itemsPerPage: null,
  collectionsPerPage: null,
  maxEntriesPerPage: 1000,
  defaultThumbnailSize: null,
  crossOriginMedia: null,
  requestHeaders: {},
  requestQueryParameters: {},
  socialSharing: ['email', 'bsky', 'mastodon', 'x'],
  preprocessSTAC: null,
  authConfig: null,
  crs: {},
  footerLinks: [{ label: "Home", url: "/" }, { label: "Documentation", url: "/documentation" }],
  footerLogos: [
    { src: "site-assets/CNES-footer.png", alt: "CNES", url: "https://cnes.fr" },
    { src: "site-assets/LAM.png", alt: "LAM", url: "https://www.lam.fr" },
    { src: "site-assets/LATMOS.jpg", alt: "LATMOS", url: "https://www.latmos.ipsl.fr" }
  ]
};
